function initHeroBlockSwipers() {
  if (!('Swiper' in window)) {
    return;
  }
  document.querySelectorAll('.hero-block:not(.swiper--initialized)').forEach((heroBlockElement) => {
    heroBlockElement.classList.add('swiper--initialized');
    const swiperElement = heroBlockElement.querySelector('.swiper');
    const swiper = new Swiper(swiperElement, {
      loop: true,
      speed: 1000,
      spaceBetween: 32,
      slidesPerView: 1,
      mousewheel: {
        forceToAxis: true
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      on: {
        scrollbarDragEnd: function(swiper, event) {
          document.body.classList.remove('body--grabbing');
        },
        scrollbarDragStart: function(swiper, event) {
          document.body.classList.add('body--grabbing');
        },
        touchEnd: function(swiper, event) {
          document.body.classList.remove('body--grabbing');
        },
        touchStart: function(swiper, event) {
          if (swiper.slides.length <= swiper.slidesPerViewDynamic()) {
            return;
          }
          document.body.classList.add('body--grabbing');
        }
      }
    });
  });
}


function initHeroBlocks() {
  initHeroBlockSwipers();
}


window.addEventListener('load', (event) => {
  initHeroBlockSwipers();
});


if (document.readyState !== 'loading') {
  initHeroBlocks();
} else {
  window.addEventListener('DOMContentLoaded', initHeroBlocks);
}
